import React from 'react';
import { makeStyles } from '@fluentui/react-components';
import { RadioButton24Regular, CheckboxUnchecked24Regular } from '@fluentui/react-icons';
import { ChoiceQuestion as ChoiceQuestionType } from '../../../../types/forms';

const useStyles = makeStyles({
  questionContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    width: '100%',
  },
  questionTitle: {
    fontFamily: '"Segoe UI", sans-serif',
    fontSize: '20px',
    fontWeight: 400,
    lineHeight: '28px',
    color: '#242424',
    marginBottom: '12px',
  },
  optionsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    paddingLeft: '20px',
  },
  optionRow: {
    display: 'flex',
    gap: '12px',
    alignItems: 'center',
  },
  radioButton: {
    fontSize: '24px',
    color: '#616161',
    flexShrink: 0,
  },
  optionText: {
    fontFamily: '"Segoe UI", sans-serif',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20px',
    color: '#242424',
  },
});

interface ChoiceQuestionViewProps {
  question: ChoiceQuestionType;
  questionNumber: number;
  onClick?: () => void;
}

export const ChoiceQuestionView: React.FC<ChoiceQuestionViewProps> = ({
  question,
  questionNumber,
  onClick,
}) => {
  const styles = useStyles();

  return (
    <div className={styles.questionContainer} onClick={onClick} style={{ cursor: onClick ? 'pointer' : 'default' }} data-question-view>
      <div className={styles.questionTitle}>
        {questionNumber}. {question.title}
        {question.required && <span style={{ color: '#d13438', marginLeft: '4px' }}>*</span>}
      </div>
      
      <div className={styles.optionsContainer}>
        {question.options.map((option) => (
          <div key={option.id} className={styles.optionRow}>
            {question.allowMultiple ? (
              <CheckboxUnchecked24Regular className={styles.radioButton} />
            ) : (
              <RadioButton24Regular className={styles.radioButton} />
            )}
            <span className={styles.optionText}>{option.text}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
